export default __webpack_public_path__ + "static/orange-8b680b7ba76f93a2e019c19dd6116b82.png";